export default __webpack_public_path__ + "static/media/druma_project2.54d19b7a.JPG";